import React from 'react';
import ReactCountryFlag from "react-country-flag";

const countries = [
  { code: "US", name: "US" },
  { code: "GB", name: "UK" },
  { code: "DE", name: "Germany" },
  { code: "IT", name: "Italy" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "IN", name: "India" },
  { code: "JP", name: "Japan" },
  { code: "NG", name: "Nigeria" },
  { code: "AE", name: "UAE" },
  { code: "NL", name: "Netherlands" },
  { code: "BR", name: "Brazil" }
];

const Webdevmarket = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
      {/* BACKGROUND GLOWS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[120px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[120px] rounded-full pointer-events-none"></div>

      {/* GRID */}
      <div className="absolute inset-0 opacity-[0.04] dark:opacity-[0.03]" 
           style={{ backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', backgroundSize: '60px 60px' }}>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto border bg-white dark:bg-[#171717] p-10 rounded-2xl border-gray-100 dark:border-gray-900">
           <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
              Trusted by Global Brands for  {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
             Development
            </span>
          </h2>
      <p className="myparagraph text-gray-500">
   We build your global business solutions for Web Developments.</p>
      </div>
   

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8">
          {countries.map((country, index) => (
            <div key={index} className="flex flex-col items-center justify-center p-4 bg-white dark:bg-[#1a1a1a] rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md transition-shadow">
              <ReactCountryFlag 
                countryCode={country.code} 
                svg 
                style={{ width: '2.5em', height: '2.5em' }} 
                title={country.name} 
              />
              <span className="mt-3 text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase">
                {country.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Webdevmarket;